module.exports = __webpack_public_path__ + "static/media/rfm_definition.dfa642bd.svg";